module.exports = __webpack_public_path__ + "static/media/فین-و-کویل-2-1-300x161.b5796e82.jpg";